// Import pollyfills & librairies
import 'loading-attribute-polyfill/dist/loading-attribute-polyfill.js'; // lazy load
// import custom
import './cssVariables';
import 'bootstrap/js/src/collapse'
import './accordion';
import './forms';
import './animations';
// import './sliders';
import './tooltips';
import './popins';
import './modals';
// import './custom-parsley';
// import './nav';
import './inputfile';
import './btn-back-to-top';
import './sticky-manager';
import './fit-to-screen-border';
import './scrollbar-overlay';

// Functions
